/**
 * This is a wrapper around Stripe's APIs that we use in our frontend code.
 * Expose the APIs that we need from Stripe.js here so we have a single place
 * to look at during API upgrades and refactors.
 *
 * Stripe.js is loaded lazily on first use to avoid blocking page load.
 */

import { loadStripe } from '@stripe/stripe-js/pure';

import type { StripeType } from 'js/src/typings/global';

const STRIPE_API_VERSION = '2025-01-27.acacia';

const PaymentService = (() => {
    let stripeInstance: StripeType = null;

    const getInstance = async (): Promise<NonNullable<StripeType>> => {
        if (!stripeInstance) {
            stripeInstance = await loadStripe(SERVER.STRIPE_PUBLISHABLE_KEY, {
                apiVersion: STRIPE_API_VERSION,
            });
            if (!stripeInstance) {
                throw new Error('Stripe.js failed to load');
            }
        }
        return stripeInstance;
    };

    return {
        confirmCardPayment: async (clientSecret: string) => {
            const stripe = await getInstance();
            return stripe.confirmCardPayment(clientSecret);
        },
        redirectToCheckout: async (sessionId: string) => {
            const stripe = await getInstance();
            return stripe.redirectToCheckout({ sessionId });
        },
    };
})();

export default PaymentService;
